//import axios from 'axios'

const state = {
  consensi: {},
};
const getters = {};
const actions = {
  async salvaDati({ commit }, payload) {
    await commit(payload.azione, payload.dati);
  },
};
const mutations = {
  setIscrizione: (state, dati) => {
    alert(JSON.stringify(dati));
    //state.riepilogo.iscrizione.facolta.val = dati.fac_scelta.CODICENU
    //state.riepilogo.iscrizione.facolta.desc = dati.fac_scelta.DECODIF
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
